<template>
  <main-content>
    <template v-slot:left>
      <i class="fa fa-cog mr-3"></i>Settings
    </template>
    <template v-slot:right>
    </template>

    <div class="col-md-12">

    <b-tabs content-class="mt-3" justified>
    <b-tab title="Profile" active>
      <profile></profile>
    </b-tab>
    <b-tab title="Station">
      <station-settings></station-settings>
    </b-tab>
    <b-tab title="Billing">
      <billing></billing>
    </b-tab>
    <!-- <b-tab title="Broadcast">
      <broadcast></broadcast>
    </b-tab> -->
    <!-- <b-tab title="Security"><p>I'm the second tab</p></b-tab>
    <b-tab title="Advanced"><p>I'm the second tab</p></b-tab>
    <b-tab title="Integrations"><p>I'm the second tab</p></b-tab> -->
    
  </b-tabs>
  <payment-success-modal ref="paymentSuccessModal"></payment-success-modal>
  <payment-failure-modal ref="paymentFailureModal"></payment-failure-modal>

    </div>
  </main-content>
</template>

<script >
import  Billing from "./Billing.vue";
import  Profile from "./Profile.vue";
import  Broadcast from "./Broadcast.vue";
import  StationSettings from "./Station.vue";
import PaymentSuccessModal from "@/components/PaymentSuccessModal.vue";
import PaymentFailureModal from "@/components/PaymentFailureModal.vue";
import ApiService from "@/plugins/ApiService";

export default {
  name: "Settings",
  components: {
    Billing,
    Profile,
    Broadcast,
    StationSettings,
    PaymentSuccessModal,
    PaymentFailureModal
  },


  data() {
    return {
      pageTitle: "Settings",

    };
  },


  methods:{

     orchardRedirect() {
      const params = new URL(document.location).searchParams;
       this.transaction_id = params.get("exttrid");
      if (this.transaction_id) {
        this.checkStatus()
      }
    },

    async checkStatus() {
      const response = await ApiService.post("settings/orchard-status",{
          id: this.transaction_id
      });


      const data = response.data;

      // console.log(data);

      if (data.status === "Approved") {
     
        this.$refs.paymentSuccessModal.openModal();
      } else {
        this.$refs.paymentFailureModal.openModal(data.reason);

      } 
    },

  },

  mounted() {
    this.orchardRedirect()
  }

  
};
</script>
